(() => {
  function init() {
    const quizzModal = document.querySelector("#quizzModal");

    const closeModal = quizzModal.querySelector(".quizz-modal-close");
    if (closeModal) {
      closeModal.addEventListener("click", (e) => {
        e.preventDefault();
        quizzModal.classList.remove("visible");
        document.body.classList.remove("no-scroll");
      });
    }

    const trackedCTAs = document.querySelectorAll(".js-tracked-cta");
    if (trackedCTAs.length === 0) return;
    trackedCTAs.forEach((cta) => {
      cta.addEventListener("click", (e) => {
        e.preventDefault();
        const alreadyTrackked = localStorage.getItem("homePageMealPlanQuizz");
        if (alreadyTrackked) {
          window.location.href = cta.href;
        } else {
          const header = document.querySelector("#shopify-section-header");
          if (header) {
            const headerHeight = header.offsetHeight - 1;
            quizzModal.style.top = `${headerHeight}px`;
          }
          document.body.classList.add("no-scroll");
          quizzModal.classList.add("visible");
        }
      });
    });
  }
  window.addEventListener("DOMContentLoaded", init);
})();
